<div class="m-radiobutton-container">
  <p-radiobutton
    [ngClass]="{
      'ng-invalid ng-dirty': error(),
    }"
    [name]="name()"
    [value]="value"
    [tabindex]="tabindex"
    [inputId]="radiobuttonInputId"
    [ariaLabelledBy]="ariaLabelledBy"
    [ariaLabel]="ariaLabel"
    [ngModel]="selectedValue()"
    (ngModelChange)="selectedValue.set($event)"
    (onClick)="onClick.emit($event)"
    (onFocus)="onFocus.emit($event)"
    (onBlur)="onBlur.emit($event)"
    [disabled]="$disabled()">
  </p-radiobutton>
  <label
    [for]="radiobuttonInputId"
    class="m-radiobutton-label"
    [class.m-radiobutton-label-selected]="
      selectedValue() === value && !error()
    ">
    <ng-content></ng-content>
  </label>
</div>
